import { css } from '@emotion/react';
import arrowLeft from '../../svgs/arrowLeft.svg';
import arrowRight from '../../svgs/arrowRight.svg';
import arrowLeftWhite from '../../svgs/arrowLeftWhite.svg';
import arrowRightWhite from '../../svgs/arrowRightWhite.svg';
import { theme } from '../../../theme';

const { sm } = theme.breakpoints;

const slideshowWrapper = css`
  min-height: 60px;
  width: 100%;
  position: relative;
  overflow: hidden;
`;

const slideshowSlide = css`
  position: absolute;
  width: 100%;
  display: flex;
  justify-content: center;
  z-index: 0 !important;
`;

const slideshowControlsWrapper = css`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  display: flex;

  & :nth-of-type(1) {
    cursor: url(${arrowLeft}), auto;
  }

  & :nth-of-type(2) {
    cursor: url(${arrowRight}), auto;
  }

  @media (max-width: ${`${sm}px`}) {
    display: none;
  }
`;

const slideshowControlsWhite = css`
  & :nth-of-type(1) {
    cursor: url(${arrowLeftWhite}), auto;
  }

  & :nth-of-type(2) {
    cursor: url(${arrowRightWhite}), auto;
  }
`;

const slideshowControlButton = css`
  width: 50%;
  height: 100%;
  border: none;
  background: transparent;
  cursor: none;
`;

export {
  slideshowWrapper,
  slideshowSlide,
  slideshowControlsWrapper,
  slideshowControlsWhite,
  slideshowControlButton,
};
